import GroupsContextProvider from '../../../context/users/GroupsContextProvider';
import RolesContextProvider from '../../../context/users/RolesContextProvider';
import UsersContextProvider from '../../../context/users/UsersContextProvider';
import {useUsersScreenContext} from '../../../context/users/UsersScreenContextProvider';
import ClientsSideFilter from './ClientsSideFilter';
import GroupsMain from './GroupScreens/GroupsMain';
import RolesMain from './RoleScreens/RolesMain';
import UserHeader from './UserHeader';
import UsersMain from './UserScreens/UsersMain';

function MainPage() {
  const {selectedScreen} = useUsersScreenContext();

  return (
    <div className="w-full h-full min-h-0 overflow-hidden">
      <div className="w-full h-full bg-grayLightBg flex gap-1">
        <ClientsSideFilter />

        <div className="flex-1 flex flex-col gap-1 min-h-0 overflow-y-auto">
          {/* Header */}
          <UserHeader />

          {selectedScreen === 'users' && (
            <UsersContextProvider>
              <UsersMain />
            </UsersContextProvider>
          )}

          {selectedScreen === 'roles' && (
            <RolesContextProvider>
              <RolesMain />
            </RolesContextProvider>
          )}

          {selectedScreen === 'groups' && (
            <GroupsContextProvider>
              <GroupsMain />
            </GroupsContextProvider>
          )}
        </div>
      </div>
    </div>
  );
}

export default MainPage;
